/*
  This page is rendered inside the Zuora iFrame, as path '/payment-method/card-callback',
  with QueryParameters:
{
  success: boolean
  responseFrom: Response_From_Submit_Page
  token: string
  signature: string
  tenantId: string
  refId?: string
  errorCode?: string
  errorMessage?: string
}
*/

import { useEffect } from "react";

import { Loader } from "ui";

import { useQueryParams } from "../hooks/useQueryParams";
import { ZuoraError } from "../types";
import { logger } from "../utils/logger";

const useHandleCallback = ({ onSuccess, onError }: ZuoraCallbackPageProps) => {
  const queryParams = useQueryParams();

  useEffect(() => {
    const responseFrom = queryParams.get("responseFrom");
    const success = queryParams.get("success") === "true";

    const errorMessage = queryParams.get("errorMessage") ?? "";
    const errorCode = queryParams.get("errorCode") ?? "";
    logger.info("User directed to Zuora card-callback page", {
      responseFrom,
      success,
      errorMessage,
      errorCode,
    });

    // TODO: what if we receive something else than Response_From_Submit_Page?
    if (responseFrom === "Response_From_Submit_Page") {
      const refId = queryParams.get("refId");
      const flow = queryParams.get("field_passthrough1") ?? undefined;
      if (success && refId) {
        onSuccess({ paymentMethodId: refId, flow });
      } else {
        onError({
          code: errorCode,
          message: errorMessage,
        });
      }
    }
  }, [queryParams, onSuccess, onError]);
};

interface ZuoraCallbackPageOnSuccessProps {
  paymentMethodId: string;
  flow?: string;
}
interface ZuoraCallbackPageProps {
  onSuccess: (props: ZuoraCallbackPageOnSuccessProps) => void;
  onError: (err: ZuoraError) => void;
}

export const ZuoraCallbackPage = ({
  onSuccess,
  onError,
}: ZuoraCallbackPageProps) => {
  useHandleCallback({ onSuccess, onError });
  return <Loader />;
};
